type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;
type LoggerLike = Pick<Console, "log" | "warn" | "error">;

export const SERVER_PLATFORM_WEBHOOK_BOOTSTRAP_SQL = [
  `CREATE TABLE IF NOT EXISTS platform_webhook_outbox (
    id SERIAL PRIMARY KEY,
    idempotency_key TEXT NOT NULL UNIQUE,
    event_type TEXT NOT NULL,
    target_url TEXT NOT NULL,
    method TEXT NOT NULL DEFAULT 'POST',
    headers_json TEXT NOT NULL DEFAULT '{}',
    payload_json TEXT NOT NULL DEFAULT '{}',
    status TEXT NOT NULL DEFAULT 'queued',
    attempt_count INTEGER NOT NULL DEFAULT 0,
    next_attempt_at TIMESTAMP DEFAULT NOW(),
    provider TEXT,
    response_status INTEGER,
    response_body_preview TEXT,
    last_error TEXT,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
    sent_at TIMESTAMP
  )`,
  `CREATE INDEX IF NOT EXISTS idx_platform_webhook_outbox_status_next_attempt
    ON platform_webhook_outbox (status, next_attempt_at)`,
  `CREATE INDEX IF NOT EXISTS idx_platform_webhook_outbox_event_created
    ON platform_webhook_outbox (event_type, created_at)`,
];

export async function ensurePlatformWebhookSchema(params: {
  rawSql: RawSql;
  isPlatform: boolean;
  logger?: LoggerLike;
}): Promise<void> {
  if (!params.isPlatform) return;
  const logger = params.logger ?? console;
  for (const statement of SERVER_PLATFORM_WEBHOOK_BOOTSTRAP_SQL) {
    await params.rawSql(statement);
  }
  logger.log("[db] platform webhook schema ✓");
}
